import { render, staticRenderFns } from "./SwitchSidebarBtn.vue?vue&type=template&id=f0c7e2da&scoped=true&"
import script from "./SwitchSidebarBtn.vue?vue&type=script&lang=js&"
export * from "./SwitchSidebarBtn.vue?vue&type=script&lang=js&"
import style0 from "./SwitchSidebarBtn.vue?vue&type=style&index=0&id=f0c7e2da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c7e2da",
  null
  
)

export default component.exports